import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { KeycloakAuthService } from '../auth/keycloak.service';
import { Roles } from '../models/roles';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private keycloakAuthService: KeycloakAuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const userRole = this.keycloakAuthService.getPrimaryRole() ?? localStorage.getItem('role');
    
    // Only allow Super Admin to access this route
    if (userRole === Roles.superAdmin) {
      return true;
    }

    // Redirect to settings home if not Super Admin
    this.router.navigate(['/settings']);
    return false;
  }
}
